import { useContext } from 'react';

import { Mode } from '@wf/components';

import LicenseModeContext from './LicenseModeContext';

function useLicenseContext() {
  const mode = useContext(LicenseModeContext);

  return {
    mode,
    viewMode: mode === Mode.view,
    createMode: mode === Mode.create,
  };
}

export default useLicenseContext;
